import { createContext, useContext, useEffect, useState } from "react";
import { fetchMe, getToken, clearToken } from "@/lib/adminApi";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  useEffect(() => {
    if (!getToken()) {
      setUser(false);
      return;
    }
    fetchMe()
      .then(setUser)
      .catch(() => {
        clearToken();
        setUser(false);
      });
  }, []);

  const logout = () => {
    clearToken();
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
